module.exports = __webpack_public_path__ + "static/media/etat-alert-grey.986f7cb4.svg";